import emit from '../../common/events';
import store from '../../store/store';
import { ariaLabelWithNewTab } from '../../common/utils/a11y-util';
import variables from '../../common/styles/variables';
import { BaseComponent } from '../base-component/base-component';
import { getOrderHistoryPageURL } from './utils/free-trial.util';
import { StoreState } from '../../store/store.interface';
import { css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { setFreeTrialTermsAccepted } from './store/free-trial.store';

/**
 * A static element to display free trial terms and conditions.
 */
@customElement('mhecomm-free-trial-terms')
export class FreeTrialTerms extends BaseComponent {
  static styles = [
    variables,
    css`
      [icon='check-circle'] {
        height: 1.5rem;
        width: 1rem;
      }

      [icon='check-circle'] svg {
        height: 0.813rem !important;
        vertical-align: baseline !important;
      }

      .term-list {
        list-style-type: none;
        padding: 0 !important;
      }

      .term-list .col.col-auto {
        padding-right: 0.375rem;
      }
    `,
  ];

  connectedCallback(): void {
    super.connectedCallback();
    this.addEventListener('mhecomm-free-trial-terms-updated', this.onFreeTrialTermsUpdatedEventHandler);
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    this.removeEventListener('mhecomm-free-trial-terms-updated', this.onFreeTrialTermsUpdatedEventHandler);
  }

  renderComp() {
    return html`
      <div>
        <div class="fs-small">
          A one cent charge will appear on your bank statement to verify your payment
          method.
        </div>
        <hr class="my-3" />
        <div class="mb-2">
          <span class="fs-small fw-bold">Free Trial Terms</span>
        </div>
        <div>
          <ul class="term-list mb-2">
            <li class="d-flex row">
              <div class="col col-auto">
                <uxt-icon icon="check-circle" size="sm"></uxt-icon>
              </div>
              <div class="col col-10 p-0 mb-1 align-self-end fs-small">Billing automatically occurs after free trial ends</div>
            </li>
            <li class="d-flex row mt-2">
              <div class="col col-auto">
                <uxt-icon icon="check-circle" size="sm"></uxt-icon>
              </div>
              <div class="col col-10 p-0 align-self-end fs-small">
                Cancel before your free trial ends in
                <a
                  href=${getOrderHistoryPageURL(store.getState() as StoreState)}
                  @click=${() => this.fireAnalytics('My Account Order History')}
                  class="fs-small"
                  aria-label="${ariaLabelWithNewTab('My Account Order History')}"
                  target="_blank"
                  >My Account &gt; Order History</a
                >
                to avoid getting billed?
              </div>
            </li>
          </ul>
          <mhecomm-checkout-terms-acceptance
            eventName="mhecomm-free-trial-terms-updated"
            label="I agree to these Free Trial Terms"
          />
        </div>
      </div>
    `;
  }

  /**
   * Updates the free trial accepted flag when the checkbox is checked or unchecked.
   *
   * @param e
   */
  onFreeTrialTermsUpdatedEventHandler(e: Event) {
    const event: CustomEvent = e as CustomEvent;
    store.dispatch(setFreeTrialTermsAccepted(event.detail.termsAccepted));
  }

  private fireAnalytics(eventName) {
    emit({
      element: this,
      name: 'click',
      detail: {
        label: eventName,
        eventName: eventName.toLowerCase().replace(/\s/g, '-'),
        url: window.location.href,
      },
    });
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-free-trial-terms': FreeTrialTerms;
  }
}
